

import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import useGet from '../api/useGet';
import { GetHeaderMenuByUser, GetHeaderMenuByUserResponse } from '@/api/dtos';

const getData = (response?: SWRResponse<GetHeaderMenuByUserResponse, GetHeaderMenuByUserResponse>) => response?.data?.headerMenu;
const getError = (response?: SWRResponse<GetHeaderMenuByUserResponse, GetHeaderMenuByUserResponse>) => (response?.error ?? response?.data)?.responseStatus;


export const useHeaderMenuByUser = (configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {

        return () => {
            return new GetHeaderMenuByUser({ });
        }
    }, []);

    return useGet(request, { getData, getError }, configuration);
}

export default useHeaderMenuByUser;